import { useLazyQuery } from '@apollo/client'
import { getApproverGroupsList, setSelectedApproverGroups } from 'cache/manage-backup'
import { enrichBackupApprovers } from 'pages/ManageBackUpPage/helperFns'
import { GET_BACKUP_APPROVERS_BY_USER } from 'queries/get-backup-approvers-by-user'
import { GetBackupApproversByPrimaryApproverRequestInput } from 'ts/interfaces/approverGroup.interface'

export const useGetBackupApproverByUser = () => {
  const [getBackupApproversByUser, { data, loading, error }] = useLazyQuery<
    any,
    { input: GetBackupApproversByPrimaryApproverRequestInput }
  >(GET_BACKUP_APPROVERS_BY_USER, {
    fetchPolicy: 'no-cache',
    onCompleted: (res) => {
      const selectedApproverGroupsList = res.backupApproversByPrimaryApprover?.backupApprovers || []
      const approverGroupsList = getApproverGroupsList()

      setSelectedApproverGroups(
        enrichBackupApprovers(approverGroupsList || [], selectedApproverGroupsList)
      )
    },
    onError: () => {
      setSelectedApproverGroups([])
    },
  })

  const handleGetBackupApproversByUser = async (
    input: GetBackupApproversByPrimaryApproverRequestInput
  ) => {
    try {
      await getBackupApproversByUser({
        variables: { input },
      })
    } catch (error) {
      return error
    }
  }

  return {
    handleGetBackupApproversByUser,
    loading,
    data,
    error,
  }
}
